import React from "react";
import Navbars from "../Components/navbar";
import Hero from "./hero";
import Secone from "./secone";
import Sectwo from "./sectwo";
import Secthree from "./secthree";
import Footer from "../Components/Footer";


const Aboutlink = () => {
    return(
        <>
        <Navbars />
        <Hero />
        <Secone />
        <Sectwo />
        <Secthree />
        <Footer />
        </>
    )
}

export default Aboutlink;